import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceDisplay } from './PriceDisplay';
export function PricingSection() {
  return <section className="bg-[#F5F5F5] py-16 px-4 md:py-20" data-id="element-223">
      <div className="max-w-[800px] mx-auto text-center" data-id="element-224">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-gray-100 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-225">
          <div className="absolute top-0 left-0 w-full h-2 bg-[#00A86B]" data-id="element-226"></div>

          <div className="inline-block bg-[#FFF3D6] text-yellow-800 font-heading font-bold text-sm px-4 py-1.5 rounded-full mb-6" data-id="element-227">
            🔥 OFERTA SOLO POR HOY
          </div>

          <div className="mb-2" data-id="element-228">
            <PriceDisplay amount={9000} className="font-heading font-bold text-[52px] text-[#00A86B] leading-none" data-id="element-229" />
          </div>

          <p className="text-gray-500 italic text-sm md:text-base mb-8" data-id="element-230">
            Menos que una rotisería para dos. Y lo usás todos los días.
          </p>

          <div className="w-full max-w-md mx-auto mb-6" data-id="element-231">
            <CTAButton data-id="element-232">QUIERO LAS RECETAS AHORA →</CTAButton>
          </div>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6 text-sm text-gray-600 font-medium" data-id="element-233">
            <div className="flex items-center gap-1.5" data-id="element-234">
              <LockIcon className="w-4 h-4 text-[#00A86B]" data-id="element-235" />
              <span data-id="element-236">Pago único</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-237">
              <ZapIcon className="w-4 h-4 text-[#00A86B]" data-id="element-238" />
              <span data-id="element-239">Sin suscripciones</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-240">
              <SmartphoneIcon className="w-4 h-4 text-[#00A86B]" data-id="element-241" />
              <span data-id="element-242">Acceso digital de por vida</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}